import * as Utils from 'Assets/Utils'

import ClientHttpRequest from "Api/ClientHttpRequest"
import Immutable from 'immutable'
import { createModal } from 'Modules/Modal'
import {isLoading} from "Modules/Loading"

const initialState = Immutable.Map({})
	.set('SearchRequirements', new Immutable.List([]))
	.set('SearchEvaluation', new Immutable.List([]))
	.set('SearchInformation', new Immutable.List([]))
	.set('TaskInformation', new Immutable.Map({}))
	.set('SearchRegister', new Immutable.List([]))
	.set('TaskRegister', new Immutable.Map({}))
	.set('Set', new Immutable.Map({}))
	.set('TaskEvaluation', new Immutable.Map({}))
	.set('SetAdquire', new Immutable.Map({}))
	.set('EvaluationTask', new Immutable.List([]))
	.set('TaskRequirement', new Immutable.List([]))
	.set('TaskResultsReports', new Immutable.List([]))

/* Types */

export const ACTION_GET_BPM_EVALUATIONS = 'ACTION_GET_BPM_EVALUATIONS'

export const ACTION_SEARCH_BPM_EVALUATION = 'ACTION_SEARCH_BPM_EVALUATION'

export const ACTION_GET_BPM_EVALUATION = 'ACTION_GET_BPM_EVALUATION'

export const ACTION_SEARCH_BPM_INFORMATION = 'ACTION_SEARCH_BPM_INFORMATION'

export const ACTION_GET_BPM_INFORMATION = 'ACTION_GET_BPM_INFORMATION'

export const ACTION_SEARCH_BPM_REGISTER = 'ACTION_SEARCH_BPM_REGISTER'

export const ACTION_GET_BPM_REGISTER = 'ACTION_GET_BPM_REGISTER'

export const ACTION_SET_BPM_PROCESS = 'ACTION_SET_BPM_PROCESS'

export const ACTION_SET_BPM_REQUIREMENTS = 'ACTION_SET_BPM_REQUIREMENTS'

export const ACTION_ADQUIRE_BPM_REQUIREMENTS = 'ACTION_ADQUIRE_BPM_REQUIREMENTS'

export const ACTION_GET_BPM_REQUIREMENT = 'ACTION_GET_BPM_REQUIREMENT'

export const ACTION_GET_BPM_RESULTS_REPORT = 'ACTION_GET_BPM_RESULTS_REPORT'

/* Reducer */

export default (state = initialState, action) => {

	switch (action.type) {
		case ACTION_SEARCH_BPM_EVALUATION:
			return state.set('SearchEvaluation', new Immutable.List(action.Obj))
		case ACTION_GET_BPM_EVALUATIONS:
			return state.set('EvaluationTask', new Immutable.List(action.Obj))
		case ACTION_GET_BPM_EVALUATION:
			return state.set('TaskEvaluation', new Immutable.Map(action.Obj))
		case ACTION_SEARCH_BPM_INFORMATION:
			return state.set('SearchInformation', new Immutable.List(action.Obj))
		case ACTION_GET_BPM_INFORMATION:
			return state.set('TaskInformation', new Immutable.Map(action.Obj))
		case ACTION_SEARCH_BPM_REGISTER:
			return state.set('SearchRegister', new Immutable.List(action.Obj))
		case ACTION_SET_BPM_REQUIREMENTS:
			return state.set('SearchRequirements', new Immutable.List(action.Obj))
		case ACTION_GET_BPM_REGISTER:
			return state.set('TaskRegister', new Immutable.Map(action.Obj))
		case ACTION_SET_BPM_PROCESS:
			return state.set('Set', new Immutable.Map(action.Obj))
		case ACTION_ADQUIRE_BPM_REQUIREMENTS:
			return state.set('SetAdquire', new Immutable.Map(action.Obj))
		case ACTION_GET_BPM_REQUIREMENT:
			return state.set('TaskRequirement', new Immutable.Map(action.Obj))
		case ACTION_GET_BPM_RESULTS_REPORT:
			return state.set('TaskResultsReports', new Immutable.List(action.Obj))
		default:
			return state;
	}
};

/* Action Creators */

export const getInformationTasks = () => {

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/information/getTasks',
			method: "POST",
			data: { } ,
			headers: Object.assign({"Authorization": sessionStorage.access_token, "Bpm": sessionStorage.bpm_token, "uid": sessionStorage.uid})
		}).request().then( response => {
			response.data.uniqueId = Utils.getUUID()

			dispatch(isLoading(false))
			dispatch({ type: ACTION_SEARCH_BPM_INFORMATION, Obj: response.data })
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const getInformationTaskByGrantee = (form) => {

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/information/getTaskByGrantee',
			method: "POST",
			data: {...form} ,
			headers: Object.assign({"Authorization": sessionStorage.access_token, "Bpm": sessionStorage.bpm_token, "uid": sessionStorage.uid})
		}).request().then( response => {
			dispatch(isLoading(false))
			return response.data
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const getInformationDetailTask = (form) => {

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/information/getDetailTask',
			method: "POST",
			data: {...form},
			headers: Object.assign({"Authorization": sessionStorage.access_token, "Bpm": sessionStorage.bpm_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch(isLoading(false))
			dispatch({ type: ACTION_GET_BPM_INFORMATION, Obj: response.data })
			return response.data
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const getInformationLockTask = (form) => {

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/information/getLockTask',
			method: "POST",
			data: {...form},
			headers: Object.assign({"Authorization": sessionStorage.access_token, "Bpm": sessionStorage.bpm_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch(isLoading(false))
			return response
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const updateInformationTask = (form) => {

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/information/updateTask',
			method: "POST",
			data: {...form},
			headers: Object.assign({"Authorization": sessionStorage.access_token, "Bpm": sessionStorage.bpm_token, "uid": sessionStorage.uid})
		}).request().then( () => {
			dispatch(isLoading(false))
			dispatch({ type: ACTION_GET_BPM_INFORMATION, Obj: {} })
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const getRegisterTasks = () => {

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/register/getTasks',
			method: "POST",
			data: { } ,
			headers: Object.assign({"Authorization": sessionStorage.access_token, "Bpm": sessionStorage.bpm_token, "uid": sessionStorage.uid})
		}).request().then( response => {
			response.data.uniqueId = Utils.getUUID()

			dispatch(isLoading(false))
			dispatch({ type: ACTION_SEARCH_BPM_REGISTER, Obj: response.data })
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const getRegisterTaskByGrantee = (form) => {

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/register/getTaskByGrantee',
			method: "POST",
			data: {...form} ,
			headers: Object.assign({"Authorization": sessionStorage.access_token, "Bpm": sessionStorage.bpm_token, "uid": sessionStorage.uid})
		}).request().then( response => {
			dispatch(isLoading(false))
			return response.data
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const getRegisterDetailTask = (form) => {

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/register/getDetailTask',
			method: "POST",
			data: {...form},
			headers: Object.assign({"Authorization": sessionStorage.access_token, "Bpm": sessionStorage.bpm_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch(isLoading(false))
			dispatch({ type: ACTION_GET_BPM_REGISTER, Obj: response.data })
			return response.data
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const getRegisterLockTask = (form) => {

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/register/getLockTask',
			method: "POST",
			data: {...form},
			headers: Object.assign({"Authorization": sessionStorage.access_token, "Bpm": sessionStorage.bpm_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch(isLoading(false))
			return response
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const updateRegisterTask = (form) => {

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/register/updateTask',
			method: "POST",
			data: {...form},
			headers: Object.assign({"Authorization": sessionStorage.access_token, "Bpm": sessionStorage.bpm_token, "uid": sessionStorage.uid})
		}).request().then( () => {
			dispatch(isLoading(false))
			dispatch({ type: ACTION_GET_BPM_REGISTER, Obj: {} })
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const getEvaluationsTasks = () => {

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/evaluation/getTasks',
			method: "POST",
			data: { } ,
			headers: Object.assign({"Authorization": sessionStorage.access_token, "Bpm": sessionStorage.bpm_token, "uid": sessionStorage.uid})
		}).request().then( response => {
			dispatch(isLoading(false))
			response.data.uniqueId = Utils.getUUID()
			dispatch({ type: ACTION_SEARCH_BPM_EVALUATION, Obj: response.data })
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const getEvaluations = (form) => {

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/evaluation/getEvaluations',
			method: "POST",
			data: {...form},
			headers: Object.assign({"Authorization": sessionStorage.access_token, "Bpm": sessionStorage.bpm_token, "uid": sessionStorage.uid})
		}).request().then( (response) => {
			dispatch(isLoading(false))
			response.data.uniqueId = Utils.getUUID()
			dispatch({ type: ACTION_GET_BPM_EVALUATIONS, Obj: !response.data.tareas ? [] : response.data.tareas.tarea })
			return response.data
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response))))
			throw error
		})
	}
}
export const getDetailTask = (idTarea) => {

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/evaluation/getDetailTask',
			method: "POST",
			data: {idTarea},
			headers: Object.assign({"Authorization": sessionStorage.access_token, "Bpm": sessionStorage.bpm_token, "uid": sessionStorage.uid})
		}).request().then( (response) => {
			dispatch(isLoading(false))
			dispatch({ type: ACTION_GET_BPM_EVALUATION, Obj: response.data  })
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const getEvaluationLockTaks = (form) => {

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/evaluation/getEvaluationLockTaks',
			method: "POST",
			data: {...form},
			headers: Object.assign({"Authorization": sessionStorage.access_token, "Bpm": sessionStorage.bpm_token, "uid": sessionStorage.uid})
		}).request().then( (response) => {
			dispatch(isLoading(false))
			return response.data
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const updateEvaluationTask = (form) => {

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/evaluation/updateEvaluationTask',
			method: "POST",
			data: {...form},
			headers: Object.assign({"Authorization": sessionStorage.access_token, "Bpm": sessionStorage.bpm_token, "uid": sessionStorage.uid})
		}).request().then( response => {
			dispatch(isLoading(false))
			dispatch({ type: ACTION_GET_BPM_EVALUATION, Obj: {} })
			return response.data
		}).catch(error => {
			dispatch(isLoading(false))
			if(error.response.data.message && error.response.data.message === 'Error de conectividad')
				return;
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const updateRequest = (form) => {

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/evaluation/updateRequest',
			method: "POST",
			data: {...form},
			headers: Object.assign({"Authorization": sessionStorage.access_token, "Bpm": sessionStorage.bpm_token, "uid": sessionStorage.uid})
		}).request().then((response) => {
			dispatch(isLoading(false))
			return response.data
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const getRequirementTasks = (form) => {

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/requirements/getRequirementTasks',
			method: "POST",
			data: {...form},
			headers: Object.assign({"Authorization": sessionStorage.access_token, "Bpm": sessionStorage.bpm_token, "uid": sessionStorage.uid})
		}).request().then( (response) => {
			dispatch(isLoading(false))
			dispatch({ type: ACTION_SET_BPM_REQUIREMENTS, Obj: response.data })
			return response.data
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const postAdquireTask = (form) => {

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/requirements/postAdquireTask',
			method: "POST",
			data: {...form},
			headers: Object.assign({"Authorization": sessionStorage.access_token, "Bpm": sessionStorage.bpm_token, "uid": sessionStorage.uid})
		}).request().then( (response) => {
			dispatch(isLoading(false))
			return response.data
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const getDetailRequirementTask = (form) => {

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/requirements/getDetailTask',
			method: "POST",
			data: {...form},
			headers: Object.assign({"Authorization": sessionStorage.access_token, "Bpm": sessionStorage.bpm_token, "uid": sessionStorage.uid})
		}).request().then( (response) => {
			dispatch(isLoading(false))
			dispatch({ type: ACTION_GET_BPM_REQUIREMENT, Obj: response.data })
			return response.data
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const updateDetailRequirementTask = (form) => {

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/requirements/updateTask',
			method: "POST",
			data: {...form},
			headers: Object.assign({"Authorization": sessionStorage.access_token, "Bpm": sessionStorage.bpm_token, "uid": sessionStorage.uid})
		}).request().then( (response) => {
			dispatch(isLoading(false))
			return response.data
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const updateStateRequirementTask = (form) => {

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/requirements/updateStateTask',
			method: "POST",
			data: {...form},
			headers: Object.assign({"Authorization": sessionStorage.access_token, "Bpm": sessionStorage.bpm_token, "uid": sessionStorage.uid})
		}).request().then( (response) => {
			dispatch(isLoading(false))
			return response.data
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const getResultsReport = (form) => {

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/informeResultados/getResultsReport',
			method: "POST",
			data: {...form},
			headers: Object.assign({"Authorization": sessionStorage.access_token, "Bpm": sessionStorage.bpm_token, "uid": sessionStorage.uid})
		}).request().then( (response) => {
			dispatch(isLoading(false))
			response.data.uniqueId = Utils.getUUID()
			dispatch({ type: ACTION_GET_BPM_RESULTS_REPORT, Obj: response.data })
			return response.data
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const initializeInforme = (form) => {

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/informeResultados/initializeInforme',
			method: "POST",
			data: {...form},
			headers: Object.assign({"Authorization": sessionStorage.access_token, "Bpm": sessionStorage.bpm_token, "uid": sessionStorage.uid})
		}).request().then( (response) => {
			dispatch(isLoading(false))
			return response.data
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const detailInformeTask = idTarea => {

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/informeResultados/detailInformeTask',
			method: "POST",
			data: {idTarea},
			headers: Object.assign({"Authorization": sessionStorage.access_token, "Bpm": sessionStorage.bpm_token, "uid": sessionStorage.uid})
		}).request().then( (response) => {
			dispatch(isLoading(false))
			return response.data
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const updateInformeTask = (form) => {

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/informeResultados/updateInformeTask',
			method: "POST",
			data: {...form},
			headers: Object.assign({"Authorization": sessionStorage.access_token, "Bpm": sessionStorage.bpm_token, "uid": sessionStorage.uid})
		}).request().then( (response) => {
			dispatch(isLoading(false))
			return response.data
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const setProcessData = (form) => {

	return (dispatch) => {
		dispatch({ type: ACTION_SET_BPM_PROCESS, Obj: form })
	}
}

export const clearProcessData = () => {
	return (dispatch) => {

		dispatch({ type: ACTION_GET_BPM_REGISTER, Obj: {} })
		dispatch({ type: ACTION_SEARCH_BPM_REGISTER, Obj: []})

		dispatch({ type: ACTION_GET_BPM_INFORMATION, Obj: {} })
		dispatch({ type: ACTION_SEARCH_BPM_INFORMATION, Obj: []})

		dispatch({ type: ACTION_GET_BPM_EVALUATION, Obj: {} })
		dispatch({ type: ACTION_SEARCH_BPM_EVALUATION, Obj: []})

		dispatch({ type: ACTION_GET_BPM_EVALUATIONS, Obj: []})
	}
}



// WEBPACK FOOTER //
// ./src/modules/Grantees/Bpm/Process.js